import { render } from "./DioroomPrivacyPolicy.vue?vue&type=template&id=626896c3&scoped=true"
import script from "./DioroomPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./DioroomPrivacyPolicy.vue?vue&type=script&lang=js"

import "./DioroomPrivacyPolicy.vue?vue&type=style&index=0&id=626896c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626896c3"]])

export default __exports__